import { showCartNotice } from './cart-notice';

const parseButton = (html) => {
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  return tmp.firstElementChild;
};

export const initLazyWishlist = () => {
  const placeholders = document.querySelectorAll('.wishlist-ajax-placeholder');
  if (!placeholders.length) return;

  const { ajaxUrl } = window.sebaWishlistAjax || {};
  if (!ajaxUrl) return;

  // Na stronie nie ma JS-a YITH (motyw wycina jego enqueue), więc podmiana
  // przycisku na wersję dla wybranego wariantu oraz AJAX-owe dodawanie i
  // usuwanie z listy (bez przeładowania strony) muszą dziać się tutaj.
  // Endpoint seba_wishlist_load renderuje shortcode dla dowolnego ID (także
  // wariacji) i zwraca świeże nonce'y do endpointów add/remove YITH.
  const buttons = new Map();   // parentId -> aktualny element przycisku w DOM
  const htmlCache = new Map(); // productId/variationId -> HTML przycisku
  const requested = new Map(); // parentId -> ostatnio żądane productId (guard na wyścig)
  let nonces = null;

  const fetchButtons = (ids) => {
    const body = new URLSearchParams({ action: 'seba_wishlist_load' });
    ids.forEach((id) => body.append('product_ids[]', id));
    return fetch(ajaxUrl, { method: 'POST', body })
      .then((r) => r.json())
      .then(({ success, data }) => {
        if (!success || !data) return {};
        if (data.nonces) nonces = data.nonces;
        return data.buttons || {};
      });
  };

  const swapButton = (parentId, productId) => {
    if (!buttons.has(parentId)) return;
    requested.set(parentId, productId);

    const apply = (html) => {
      if (requested.get(parentId) !== productId) return;
      const target = buttons.get(parentId);
      const newEl = parseButton(html);
      if (!newEl || !target || !target.isConnected) return;
      target.replaceWith(newEl);
      buttons.set(parentId, newEl);
    };

    const cached = htmlCache.get(productId);
    if (cached) {
      apply(cached);
      return;
    }

    fetchButtons([productId])
      .then((data) => {
        const html = data[productId];
        if (!html) return;
        htmlCache.set(productId, html);
        apply(html);
      })
      .catch(() => {});
  };

  // AJAX-owe dodawanie/usuwanie zamiast nawigacji linkiem — bez przeładowania
  // strony wybrany wariant zostaje. Href przycisku to '#' (motyw nadpisuje
  // szablony YITH w woocommerce/add-to-wishlist-{button,remove}.php, żeby nie
  // rozsiewać crawlowalnych adresów ?add_to_wishlist=<id>&_wpnonce=…), więc
  // nawigacja linkiem nie jest już fallbackiem — kliknięcie blokujemy zawsze.
  // Nonce'a nie może brakować: przychodzi tą samą odpowiedzią
  // seba_wishlist_load, która wstawiła ten przycisk do DOM.
  document.addEventListener('click', (e) => {
    const link = e.target.closest(
      '.yith-wcwl-add-to-wishlist a.add_to_wishlist, .yith-wcwl-add-to-wishlist a.delete_item'
    );
    if (!link) return;

    const container = link.closest('.yith-wcwl-add-to-wishlist');
    if (!container) return;

    e.preventDefault();

    const isRemove = link.classList.contains('delete_item');
    const productId = String(link.dataset.productId || '');
    const nonce = nonces && (isRemove ? nonces.remove : nonces.add);
    if (!productId || !nonce) return;

    if (container.classList.contains('seba-wl-busy')) return;
    container.classList.add('seba-wl-busy');
    container.style.opacity = '0.5';

    const action = isRemove ? 'remove_from_wishlist' : 'add_to_wishlist';
    const body = new URLSearchParams({ action, nonce, context: 'frontend' });
    body.append(action, productId);

    fetch(ajaxUrl, { method: 'POST', body })
      .then((r) => r.json())
      .then((response) => {
        // Licznik w navbarze (components/wishlist.js) nasłuchuje tych eventów
        document.dispatchEvent(new Event(isRemove ? 'removed_from_wishlist' : 'added_to_wishlist'));
        // Odpowiedź add_to_wishlist niesie message (uwzględnia filtry YITH z admina);
        // remove_from_wishlist go nie zwraca (kolejkuje server-side notice na przeładowanie),
        // więc dla usunięcia używamy stałego, przetłumaczalnego tekstu.
        const message = isRemove
          ? wp.i18n.__('Product removed from your wishlist', 'smartwood')
          : response && response.message;
        showCartNotice(message, isRemove ? 'woocommerce-info' : 'woocommerce-message');
        // Transient po stronie serwera zinwalidował hook YITH — dociągnij świeży stan
        htmlCache.delete(productId);
        return fetchButtons([productId]);
      })
      .then((data) => {
        const html = data && data[productId];
        if (!html) return;
        htmlCache.set(productId, html);
        const newEl = parseButton(html);
        if (!newEl || !container.isConnected) return;
        container.replaceWith(newEl);
        buttons.forEach((el, key) => {
          if (el === container) buttons.set(key, newEl);
        });
      })
      .catch(() => {
        showCartNotice(
          wp.i18n.__('Something went wrong, please try again', 'smartwood'),
          'woocommerce-error'
        );
      })
      .finally(() => {
        container.classList.remove('seba-wl-busy');
        container.style.opacity = '';
      });
  });

  // WooCommerce emituje found_variation/reset_data przez jQuery .trigger() —
  // to eventy niewidoczne dla addEventListener, więc tylko ta subskrypcja
  // wymaga jQuery. Formularz wariantów i tak nie działa bez jQuery.
  const $ = window.jQuery;

  if ($) {
    $(document).on('found_variation', '.variations_form', function (e, variation) {
      const parentId = this.dataset.product_id || '';
      const variationId = variation && variation.variation_id;
      if (parentId && variationId) swapButton(String(parentId), String(variationId));
    });

    $(document).on('reset_data', '.variations_form', function () {
      const parentId = this.dataset.product_id || '';
      if (parentId) swapButton(String(parentId), String(parentId));
    });
  }

  const initialIds = [...placeholders]
    .map((el) => el.dataset.productId)
    .filter(Boolean);

  fetchButtons(initialIds)
    .then((data) => {
      placeholders.forEach((placeholder) => {
        const id = placeholder.dataset.productId;
        const html = data[id];
        if (!html) return;
        htmlCache.set(id, html);
        const newEl = parseButton(html);
        if (!newEl) return;
        placeholder.replaceWith(newEl);
        buttons.set(id, newEl);
      });

      // Wariant mógł zostać wybrany (URL, domyślne atrybuty) zanim przycisk
      // trafił do DOM — odczytaj aktualny stan wprost z ukrytego pola
      // formularza, bez re-triggerowania eventów WC.
      document.querySelectorAll('.variations_form').forEach((form) => {
        const parentId = form.dataset.product_id || '';
        const input = form.querySelector('input[name="variation_id"]');
        const variationId = input ? String(input.value || '') : '';
        if (parentId && variationId && variationId !== '0') {
          swapButton(String(parentId), variationId);
        }
      });
    })
    .catch(() => {});
};
